import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useSnapchatBusinessManagerStore = defineStore({
  id: 'snapchatBusinessManagerStore',
  state: () => ({
    snapchatBusinessManagers: [],
    snapchatBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getSnapchatBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.snapchatBusinessManagersLoading = true

      try {
        const {data} = await axios.get('snapchat/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.snapchatBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.snapchatBusinessManagersLoading = false
      }
    },
  },
})
